<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 15px; ">
			<Form ref="searchForm" :model="searchForm" label-position="left" :label-width="70" inline>
				<FormItem label="用户名"><Input type="text" v-model="searchForm.name" placeholder="用户名/登陆账号" /></FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
			</Form>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row, index }" slot="state">
				<Tag color="success" v-if="row.stateflag">正常</Tag>
				<Tag color="error" v-else>禁用</Tag>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="warning" @click="showModifyModal(row.id)">
					修改
				</Button>
			</template>

			<template slot="header">
				<div class="flex justify-between">
					<div span="12" class="padding-left">
						<Button type="primary" @click="modalAddShow=true">
							新建账号
						</Button>
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
		<Modal v-model="modalAddShow" title="添加管理员" :footer-hide="true" :width="800">
			<div style="position: relative;">
				<Form ref="formAdd" :model="formAdd" label-position="right" :label-width="100" label-colon>
					<FormItem label="登陆账号">
						<Input v-model="formAdd.username" show-word-limit maxlength="20" style="width:200px;" />
					</FormItem>
					<FormItem label="登陆密码">
						<Input v-model="formAdd.pass" style="width:200px;" show-word-limit maxlength="32" />
					</FormItem>
					<FormItem label="状态">
						<i-switch v-model="formAdd.stateflag" size="large" :true-value="1" :false-value="0">
							<span slot="open">正常</span>
							<span slot="close">禁用</span>
						</i-switch>
					</FormItem>
					<FormItem label="操作权限">
						<CheckboxGroup v-model="formAdd.purview.client">
							<div class="solid radius">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">客户端</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="1001">小程序配置</Checkbox>
									<Checkbox label="1002">会员管理</Checkbox>
									<Checkbox label="1003">积分管理</Checkbox>
									<Checkbox label="1004">推广管理</Checkbox>
									<Checkbox label="1005">提现管理</Checkbox>
									<Checkbox label="1006">页面管理</Checkbox>
									<Checkbox label="1007">活动管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formAdd.purview.sf">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">服务师傅端</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="2001">小程序配置</Checkbox>
									<Checkbox label="2002">师傅管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formAdd.purview.order">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">订单管理</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="3001">订单设置</Checkbox>
									<Checkbox label="3002">订单管理</Checkbox>
									<Checkbox label="3004">优惠券管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formAdd.purview.public">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">公共信息管理</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="4001">检测站管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formAdd.purview.admin">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">系统管理</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="5001">管理员管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
					</FormItem>
					<FormItem>
						<Button type="primary" @click="submitAdd('formAdd')">提交</Button>
						<Button style="margin-left: 8px" @click="modalAddShow=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="loadingModify">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
		<Modal v-model="modalModify" title="修改帐号" :footer-hide="true" :width="800">
			<div style="position: relative;">
				<Form ref="formModify" :model="formModify" label-position="right" :label-width="100" label-colon>
					<FormItem label="登陆账号">
						<span class="text-bold text-lg text-blue">{{formModify.username}}</span>

					</FormItem>
					<FormItem label="新密码">
						<Input v-model="formModify.newpass" placeholder="如果不修改密码请留空" style="width:200px;" show-word-limit maxlength="32" />
					</FormItem>
					<FormItem label="状态">
						<i-switch v-model="formModify.stateflag" size="large" :true-value="1" :false-value="0">
							<span slot="open">正常</span>
							<span slot="close">禁用</span>
						</i-switch>
					</FormItem>
					<FormItem label="操作权限">
						<CheckboxGroup v-model="formModify.purview.client">
							<div class="solid radius">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">客户端</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="1001">小程序配置</Checkbox>
									<Checkbox label="1002">会员管理</Checkbox>
									<Checkbox label="1003">积分管理</Checkbox>
									<Checkbox label="1004">推广管理</Checkbox>
									<Checkbox label="1005">提现管理</Checkbox>
									<Checkbox label="1006">页面管理</Checkbox>
									<Checkbox label="1007">活动管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formModify.purview.sf">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">服务师傅端</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="2001">小程序配置</Checkbox>
									<Checkbox label="2002">师傅管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formModify.purview.order">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">订单管理</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="3001">订单设置</Checkbox>
									<Checkbox label="3002">订单管理</Checkbox>
									<Checkbox label="3004">优惠券管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formModify.purview.public">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">公共信息管理</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="4001">检测站管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
						<CheckboxGroup v-model="formModify.purview.admin">
							<div class="solid radius margin-top">
								<div class="padding-lr padding-tb-xs solid-bottom">
									<span class="text-bold text-black text-lg">系统管理</span>
								</div>
								<div class="padding-lr padding-tb-sm">
									<Checkbox label="5001">管理员管理</Checkbox>
								</div>
							</div>
						</CheckboxGroup>
					</FormItem>
					<FormItem>
						<Button type="primary" @click="submitModify('formModify')">提交</Button>
						<Button style="margin-left: 8px" @click="modalModify=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="loadingModify">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '帐号',
						align: 'center',
						key: 'username'
					},
					{
						title: '状态',
						slot: 'state',
						align: 'center'
					},
					{
						title: '创建时间',
						key: 'addtime',
						align: 'center'
					},
					{
						title: '登陆次数',
						key: 'logintimes',
						align: 'center'
					},
					{
						title: '首次登陆时间',
						key: 'firstlogintime',
						align: 'center'
					},
					{
						title: '最后登陆时间',
						key: 'lastlogintime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						width: 220

					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					kname: ''
				},
				modalAddShow: false,
				formAdd: {
					stateflag: 1,
					purview: {
					}
				},
				modalModify: false,
				loadingModify: false,
				formModify: {
					purview: {
					}
				}
			};
		},
		methods: {
			submitAdd() {
				var that = this;
				this.loadingAdd = true;
				this.$http.post('/server/api/admin/user/index.php?a=add', this.$qs.stringify(this.formAdd)).then(
					res => {
						this.loadingAdd = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.$Modal.success({
								title: '操作成功',
								content: res.data.msg,
								onOk: () => {
									this.modalAddShow = false;
									this.loadinfos();
								}
							});
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingAdd = false;
						this.$Message.error('系统错误');
					}
				);
			},
			showModifyModal(id) {
				this.modalModify = true;
				this.loadingModify = true;
				this.$http.post('/server/api/admin/user/index.php?a=getinfo', {id:id}).then(
					res => {
						this.loadingModify = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.formModify=res.data.data;
							this.loadingModify = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingModify = false;
						this.$Message.error('系统错误');
					}
				);
			},
			submitModify() {
				var that = this;
				this.loadingModify = true;
				this.$http.post('/server/api/admin/user/index.php?a=modify', this.$qs.stringify(this.formModify)).then(
					res => {
						this.loadingModify = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.$Modal.success({
								title: '操作成功',
								content: res.data.msg,
								onOk: () => {
									this.modalModify = false;
									this.loadinfos();
								}
							});
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingModify = false;
						this.$Message.error('系统错误');
					}
				);
			},
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/admin/user/index.php?a=list', this.searchForm).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			}
		},
		created() {
			this.loadinfos();
		}
	};
</script>

<style>
	.demo-spin-icon-load {
		font-size: 5em;
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
